import { render, staticRenderFns } from "./DataMain.vue?vue&type=template&id=505075c7&scoped=true&"
import script from "./DataMain.vue?vue&type=script&lang=js&"
export * from "./DataMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "505075c7",
  null
  
)

export default component.exports